import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#4a0402] text-white relative overflow-hidden">
      
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* School Identity */}
          <div className="lg:col-span-1">
            <div className="mb-8">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-4 py-2 text-sm font-medium uppercase tracking-wider mb-4 rounded-full">
                Est. 1889
              </span>
              <h3 className="text-2xl font-light text-white mb-3 leading-tight">
                P.S. 11X <span className="font-bold">Highbridge</span>
              </h3>
              <p className="text-white/80 text-sm leading-relaxed mb-6">
                One of the oldest operating elementary schools in The Bronx, building futures through excellence and innovation.
              </p>
            </div>
            
            {/* Contact */}
            <div className="space-y-3 mb-6">
              <p className="text-white/90 text-sm font-medium">1257 Ogden Avenue, Bronx, NY 10452</p>
              <p className="text-white/90 text-sm font-medium">1399 Ogden Ave, Bronx, NY 10452</p>
              <a href="tel:718-329-8000" className="text-white hover:text-white/80 transition-colors text-sm font-bold block">
                (718) 329-8000
              </a>
            </div>
            
            {/* Social Media */}
            <div className="flex space-x-3">
              <span role="img" aria-label="Facebook" className="w-10 h-10 bg-white/10 backdrop-blur-sm text-white rounded-lg flex items-center justify-center border border-white/20">
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </span>
              <span role="img" aria-label="Instagram" className="w-10 h-10 bg-white/10 backdrop-blur-sm text-white rounded-lg flex items-center justify-center border border-white/20">
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.017 0C8.396 0 7.989.013 7.041.048 6.094.082 5.52.204 5.036.43a5.493 5.493 0 0 0-1.987 1.292A5.493 5.493 0 0 0 1.757 3.71C1.531 4.194 1.409 4.768 1.375 5.715.013 6.663 0 7.07 0 10.691v2.618c0 3.621.013 4.028.048 4.976.034.947.156 1.521.382 2.005a5.493 5.493 0 0 0 1.292 1.987 5.493 5.493 0 0 0 1.987 1.292c.484.226 1.058.348 2.005.382.948.035 1.355.048 4.976.048h2.618c3.621 0 4.028-.013 4.976-.048.947-.034 1.521-.156 2.005-.382a5.493 5.493 0 0 0 1.987-1.292 5.493 5.493 0 0 0 1.292-1.987c.226-.484.348-1.058.382-2.005.035-.948.048-1.355.048-4.976V7.691c0-3.621-.013-4.028-.048-4.976-.034-.947-.156-1.521-.382-2.005A5.493 5.493 0 0 0 19.778 1.757 5.493 5.493 0 0 0 17.791.465C17.307.239 16.733.117 15.786.083 14.838.048 14.431.035 10.81.035L12.017 0zm0 2.162c3.204 0 3.584.012 4.85.07.3.055.78.166 1.207.415.427.25.78.602 1.03 1.03.249.427.36.907.415 1.207.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.055.3-.166.78-.415 1.207-.25.427-.602.78-1.03 1.03-.427.249-.907.36-1.207.415-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-.3-.055-.78-.166-1.207-.415-.427-.25-.78-.602-1.03-1.03-.249-.427-.36-.907-.415-1.207-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.055-.3.166-.78.415-1.207.25-.427.602-.78 1.03-1.03.427-.249.907-.36 1.207-.415 1.266-.058 1.646-.07 4.85-.07z" clipRule="evenodd" />
                </svg>
              </span>
              <span role="img" aria-label="X (Twitter)" className="w-10 h-10 bg-white/10 backdrop-blur-sm text-white rounded-lg flex items-center justify-center border border-white/20">
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </span>
            </div>
          </div>
          
          {/* Navigation Links - Updated to match current site structure */}
          <nav aria-label="Footer navigation" className="lg:col-span-2">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {/* Our School */}
              <div>
                <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Our School</h4>
                <ul className="space-y-3">
                  <li><Link to="/mission-vision" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Mission & Vision</Link></li>
                  <li><Link to="/history" className="text-white/80 hover:text-white transition-colors text-sm font-medium">History</Link></li>
                  <li><Link to="/principal-message" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Principal's Message</Link></li>
                  <li><Link to="/our-buildings" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Our 2 Buildings</Link></li>
                </ul>
              </div>

              {/* Academics */}
              <div>
                <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Academics</h4>
                <ul className="space-y-3">
                  <li><Link to="/classes" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Classes</Link></li>
                  <li><Link to="/learning-resources" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Learning Resources</Link></li>
                  <li><Link to="/calendar" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Calendar</Link></li>
                  <li><Link to="/pbis" className="text-white/80 hover:text-white transition-colors text-sm font-medium">PBIS</Link></li>
                </ul>
              </div>

              {/* Enrichment */}
              <div>
                <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Enrichment</h4>
                <ul className="space-y-3">
                  <li><Link to="/library" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Library</Link></li>
                  <li><Link to="/art" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Art</Link></li>
                  <li><span className="text-white/80 text-sm font-medium">Music</span></li>
                  <li><Link to="/gym" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Gym</Link></li>
                </ul>
              </div>

              {/* Community */}
              <div>
                <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Community</h4>
                <ul className="space-y-3">
                  <li><Link to="/gallery" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Gallery</Link></li>
                  <li><Link to="/staff" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Staff Directory</Link></li>
                  <li><Link to="/parents" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Parents</Link></li>
                  <li><Link to="/teacher-login" className="text-white/80 hover:text-white transition-colors text-sm font-medium">Teacher Login</Link></li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-white/20 relative z-10">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-2 md:space-y-0">
            <p className="text-white/80 text-sm font-medium">
              © {new Date().getFullYear()} P.S. 11X The Highbridge School • Community School District 9
            </p>
            <div className="flex space-x-6">
              <span className="text-white/80 text-sm font-medium">Privacy</span>
              <span className="text-white/80 text-sm font-medium">Terms</span>
              <span className="text-white/80 text-sm font-medium">Title IX</span>
            </div>
          </div>

          {/* NexSav Credit */}
          <div className="mt-4 pt-4 border-t border-white/5">
            <a
              href="https://nexsav.net"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 text-white/60 hover:text-white/90 transition-all duration-300 group"
            >
              <img
                src="/media/images/nexsav-logo.png"
                alt=""
                aria-hidden="true"
                width={136}
                height={128}
                loading="lazy"
                className="h-5 w-auto opacity-60 group-hover:opacity-90 transition-opacity duration-300"
              />
              <span className="text-xs font-medium tracking-wide">
                Website designed & developed by <span className="font-semibold">NexSav</span>
                <span className="sr-only"> (opens in a new tab)</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 